






































import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { throttle } from 'lodash-es';
import QuestionTooltip from '../question-tooltip/index.vue';
import { trackEvent } from './../../../utils/index';

const name = 'ttam-behavior-container';

export default defineComponent({
  components: { QuestionTooltip },
  model: { prop: 'contentVisible', event: 'visible-change' },
  props: {
    /** 标题 */
    title: { type: String, default: 'title' },
    /** 描述 */
    descript: { type: String, default: 'It is descript.' },
    /** 是否已有选中项 */
    hasSelected: { type: Boolean, default: false },
    /** 是否展开 */
    contentVisible: { type: Boolean, default: false },
    hint: { type: String, default: '' },
    showKey: { type: String, default: '' },
    removeKey: { type: String, default: '' },
    hintHover: { type: String, default: '' },
  },
  setup(props, ctx) {
    const { hasSelected, contentVisible } = toRefs(props);
    // const { isControlGroup } = useSplitTestTool();
    const isControlGroup = computed(() => false);

    const containerClass = computed(() => {
      if (contentVisible.value) {
        return 'open';
      }
      if (hasSelected.value) {
        return 'has-value';
      }

      return '';
    });

    const isDefaultLayout = computed(() => !contentVisible.value && !hasSelected.value);

    const iconClass = computed(() => {
      const classArr = ['icon'];
      if (hasSelected.value || contentVisible.value) {
        classArr.push('is-arrow');
      }
      if (contentVisible.value) {
        classArr.push('arrow-open');
      }

      return classArr;
    });

    const changeContentVisible = throttle(() => {
      ctx.emit('visible-change', !contentVisible.value);
      props.showKey && trackEvent(props.showKey);
    }, 500);

    function onRemove() {
      if (isControlGroup.value) {
        return;
      }
      if (contentVisible.value) {
        changeContentVisible();
      }
      ctx.emit('remove');
      props.removeKey && trackEvent(props.removeKey);
    }

    /**
     * 只大写首字母
     */
    function sentenceUppercase(str) {
      return str.replace(/^\S/, s => s.toUpperCase());
    }

    return {
      name,
      iconClass,
      containerClass,
      isDefaultLayout,
      isControlGroup,

      onRemove,
      sentenceUppercase,
      changeContentVisible,
    };
  },
});
